const WhatsAppChatWindow = ({
    activeChat,
    messages,
    loadingHistory,
    sendingMessage,
    newMessage,
    setNewMessage,
    onSendMessage,
    onShowUserInfo,
    onEditContactClick,
    onDeleteContactClick,
    onBackToList,
    getPhotoUrl,
    getCountryFlag,
    getCountryFromWhatsAppId,
    t
}) => {

    const ensureHttps = (url) => {
        if (!url) return "";
        if (url.startsWith("http://")) {
            return "https://" + url.slice(7);
        }
        return url;
    };

    const formatMessageText = (text) => {
        if (!text) return "";
        const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
        const parts = text.split(urlRegex);
        if (parts.length === 1) return text;

        return parts.map((part, index) => {
            if (part.match(urlRegex)) {
                const href = part.startsWith("http") ? part : `http://${part}`;
                return (
                    <a
                        key={index}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="whatsapp-message-link"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };

    const getMessageText = (msg) => {
        if (msg.textMessage) return msg.textMessage;
        if (msg.TextMessage) return msg.TextMessage;
        if (msg.extendedTextMessage && msg.extendedTextMessage.text) return msg.extendedTextMessage.text;
        if (msg.ExtendedTextMessage && msg.ExtendedTextMessage.Text) return msg.ExtendedTextMessage.Text;

        const messageData = msg.messageData || msg.MessageData;
        if (messageData) {
            const textData = messageData.textMessageData || messageData.TextMessageData;
            if (textData) {
                return textData.textMessage || textData.TextMessage || textData.text || textData.Text;
            }
            const extendedData = messageData.extendedTextMessageData || messageData.ExtendedTextMessageData;
            if (extendedData) {
                return extendedData.text || extendedData.Text;
            }
        }
        return t("Pages.WhatsApp.nonTextContent");
    };

    const renderMessageContent = (msg) => {
        const typeMessage = msg.typeMessage || msg.TypeMessage ||
            (msg.messageData && (msg.messageData.typeMessage || msg.messageData.TypeMessage)) ||
            (msg.MessageData && (msg.MessageData.TypeMessage || msg.MessageData.typeMessage));

        let fileUrl = msg.fileUrl || msg.FileUrl || msg.downloadUrl || msg.DownloadUrl || msg.url || msg.Url;
        let caption = msg.caption || msg.Caption || msg.textMessage || msg.TextMessage;
        let fileName = msg.fileName || msg.FileName;

        const messageData = msg.messageData || msg.MessageData;
        if (messageData) {
            const fileMsgData = messageData.fileMessageData || messageData.FileMessageData;
            const imgData = messageData.imageMessageData || messageData.ImageMessageData || fileMsgData;
            const videoData = messageData.videoMessageData || messageData.VideoMessageData || fileMsgData;
            const audioData = messageData.audioMessageData || messageData.AudioMessageData || fileMsgData;
            const docData = messageData.documentMessageData || messageData.DocumentMessageData || fileMsgData;

            if (imgData && typeMessage === "imageMessage") {
                fileUrl = fileUrl || imgData.fileUrl || imgData.FileUrl || imgData.downloadUrl || imgData.DownloadUrl || imgData.url || imgData.Url;
                caption = caption || imgData.caption || imgData.Caption;
            } else if (videoData && typeMessage === "videoMessage") {
                fileUrl = fileUrl || videoData.fileUrl || videoData.FileUrl || videoData.downloadUrl || videoData.DownloadUrl || videoData.url || videoData.Url;
                caption = caption || videoData.caption || videoData.Caption;
            } else if (audioData && typeMessage === "audioMessage") {
                fileUrl = fileUrl || audioData.fileUrl || audioData.FileUrl || audioData.downloadUrl || audioData.DownloadUrl || audioData.url || audioData.Url;
            } else if (docData && typeMessage === "documentMessage") {
                fileUrl = fileUrl || docData.fileUrl || docData.FileUrl || docData.downloadUrl || docData.DownloadUrl || docData.url || docData.Url;
                fileName = fileName || docData.fileName || docData.FileName;
                caption = caption || docData.caption || docData.Caption;
            }
        }

        fileUrl = ensureHttps(fileUrl);

        switch (typeMessage) {
            case "imageMessage":
                return (
                    <div className="whatsapp-media-image-container">
                        {fileUrl ? (
                            <img src={fileUrl} alt={caption || "WhatsApp Image"} className="whatsapp-media-image" onClick={() => window.open(fileUrl, '_blank')} />
                        ) : (
                            <div className="whatsapp-media-placeholder">
                                <i className="fal fa-image"></i>
                                <span>{t("Pages.WhatsApp.imageNotAvailable")}</span>
                            </div>
                        )}
                        {caption && <p className="whatsapp-media-caption">{formatMessageText(caption)}</p>}
                    </div>
                );
            case "videoMessage":
                return (
                    <div className="whatsapp-media-video-container">
                        {fileUrl ? (
                            <video src={fileUrl} controls className="whatsapp-media-video" />
                        ) : (
                            <div className="whatsapp-media-placeholder">
                                <i className="fal fa-video"></i>
                                <span>{t("Pages.WhatsApp.videoNotAvailable")}</span>
                            </div>
                        )}
                        {caption && <p className="whatsapp-media-caption">{formatMessageText(caption)}</p>}
                    </div>
                );
            case "audioMessage":
                return (
                    <div className="whatsapp-media-audio-container">
                        {fileUrl ? (
                            <div className="d-flex flex-column gap-1">
                                <audio controls className="whatsapp-media-audio">
                                    <source src={fileUrl} type="audio/ogg" />
                                    <source src={fileUrl} type="audio/mpeg" />
                                    <source src={fileUrl} type="audio/mp4" />
                                    Your browser does not support the audio element.
                                </audio>
                                <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="whatsapp-audio-download-link text-muted small mt-1 text-left">
                                    <i className="fal fa-external-link"></i> {t("Pages.WhatsApp.playDownloadInNewWindow")}
                                </a>
                            </div>
                        ) : (
                            <div className="whatsapp-media-placeholder">
                                <i className="fal fa-microphone"></i>
                                <span>{t("Pages.WhatsApp.audioNotAvailable")}</span>
                            </div>
                        )}
                    </div>
                );
            case "documentMessage":
                return (
                    <div className="whatsapp-media-document-container">
                        <div className="whatsapp-document-card">
                            <i className="fal fa-file-alt whatsapp-document-icon"></i>
                            <div className="whatsapp-document-info">
                                <span className="whatsapp-document-name">{fileName || t("Pages.WhatsApp.document")}</span>
                                {fileUrl && (
                                    <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="whatsapp-document-download">
                                        <i className="fal fa-download"></i> {t("Pages.WhatsApp.download")}
                                    </a>
                                )}
                            </div>
                        </div>
                        {caption && <p className="whatsapp-media-caption">{formatMessageText(caption)}</p>}
                    </div>
                );
            default:
                return (
                    <span className="whatsapp-message-text">
                        {formatMessageText(getMessageText(msg))}
                    </span>
                );
        }
    };

    const formatTime = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp * 1000);
        return date.toLocaleTimeString("ar-EG", { hour: "2-digit", minute: "2-digit" });
    };

    const chatName = activeChat.name || activeChat.id.split('@')[0];
    const initials = chatName.substring(0, 1).toUpperCase();
    const photoUrl = activeChat.systemUser && activeChat.systemUser.photo ? getPhotoUrl(activeChat.systemUser.photo) : (activeChat.avatar || activeChat.image || null);
    const countryCode = activeChat.systemUser && activeChat.systemUser.country ? activeChat.systemUser.country.toLowerCase() : getCountryFromWhatsAppId(activeChat.id);

    return (
        <div className="whatsapp-main-chat">
            {/* Header */}
            <div className="whatsapp-chat-header">
                <div className="whatsapp-chat-header-info">
                    {onBackToList && (
                        <button
                            type="button"
                            className="btn btn-link p-0 ml-2 whatsapp-back-btn text-dark"
                            onClick={onBackToList}
                            title={t("Close") || "رجوع"}
                            style={{ fontSize: '20px', border: 'none', background: 'transparent', cursor: 'pointer' }}
                        >
                            <i className="fal fa-arrow-right"></i>
                        </button>
                    )}
                    <div
                        className="whatsapp-avatar clickable-avatar ml-2"
                        title={t("Pages.WhatsApp.showUserInfo")}
                        onClick={() => onShowUserInfo(activeChat)}
                    >
                        {photoUrl ? (
                            <img src={photoUrl} alt={chatName} className="whatsapp-avatar-img" />
                        ) : (
                            initials
                        )}
                    </div>
                    <div>
                        <h6 className="whatsapp-active-name">
                            {chatName}
                            {countryCode && (
                                <img
                                    src={process.env.PUBLIC_URL + getCountryFlag(countryCode)}
                                    className="country-flag-icon"
                                    title={countryCode.toUpperCase()}
                                    alt={countryCode.toUpperCase()}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                            )}
                            {activeChat.systemUser && (
                                <span className="system-user-badge" title={t("Pages.WhatsApp.systemUser")}>
                                    <i className="fal fa-shield-check"></i>
                                </span>
                            )}
                        </h6>
                        <p className="whatsapp-active-status">{t("Pages.WhatsApp.statusOnline")}</p>
                    </div>
                </div>
                <div className="whatsapp-sidebar-actions">
                    <button
                        className="whatsapp-icon-btn text-success"
                        title={t("Pages.WhatsApp.showUserInfo")}
                        onClick={() => onShowUserInfo(activeChat)}
                    >
                        <i className="fal fa-info-circle"></i>
                    </button>
                    <button
                        className="whatsapp-icon-btn"
                        title={t("Pages.WhatsApp.editContact")}
                        onClick={() => {
                            const nameParts = chatName.split(' ');
                            const fName = nameParts[0] || "";
                            const lName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : "";
                            onEditContactClick(fName, lName);
                        }}
                    >
                        <i className="fal fa-user-edit"></i>
                    </button>
                    <button
                        className="whatsapp-icon-btn"
                        title={t("Pages.WhatsApp.deleteContact")}
                        onClick={onDeleteContactClick}
                    >
                        <i className="fal fa-trash-alt"></i>
                    </button>
                </div>
            </div>

            {/* Messages Drawer */}
            <div className="whatsapp-messages-area">
                {loadingHistory ? (
                    <div className="text-center py-5 my-auto">
                        <i className="fa-spin fas fa-spinner text-success h3"></i>
                    </div>
                ) : messages.length === 0 ? (
                    <div className="text-center py-5 my-auto text-muted">
                        <p>{t("NoInfo")}</p>
                    </div>
                ) : (
                    messages.map((msg, index) => {
                        const isOutgoing = msg.type === "outgoing" || msg.Type === "outgoing";
                        return (
                            <div
                                key={msg.idMessage || msg.IdMessage || index}
                                className={`whatsapp-message-wrapper ${isOutgoing ? "outgoing" : "incoming"}`}
                            >
                                <div className="whatsapp-message-bubble">
                                    {renderMessageContent(msg)}
                                    <span className="whatsapp-message-time">
                                        {formatTime(msg.timestamp || msg.Timestamp)}
                                        {isOutgoing && (
                                            <i className="fal fa-check-double whatsapp-message-status read ml-1"></i>
                                        )}
                                    </span>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

            {/* Input Bar */}
            <form className="whatsapp-input-bar" onSubmit={onSendMessage}>
                <input
                    type="text"
                    className="whatsapp-input-field"
                    placeholder={t("Pages.WhatsApp.typeMessagePlaceholder")}
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    disabled={sendingMessage}
                />
                <button
                    type="submit"
                    className="whatsapp-icon-btn"
                    disabled={!newMessage.trim() || sendingMessage}
                    title={t("Pages.WhatsApp.send")}
                >
                    {sendingMessage ? (
                        <i className="fa-spin fas fa-spinner text-success"></i>
                    ) : (
                        <i className="fal fa-paper-plane" style={{ transform: 'scaleX(-1)' }}></i>
                    )}
                </button>
            </form>
        </div>
    );
};

export default WhatsAppChatWindow;
